let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gCA9W")).then(() => parcelRequire('8gRGg'));